import { Globe, Settings2, Rocket, type LucideIcon } from "lucide-react";

// A single step in the "how it works" stepper.
export type Step = {
    icon: LucideIcon;
    title: string;
    description: string;
};

// Three steps from sign-up to running the gym, shown in a pinned stepper.
export const STEPS: Step[] = [
    {
        icon: Globe,
        title: "Create your gym account",
        description:
            "Sign up and your gym gets its own private space with a personal login link (like yourgym.gymmart.app) — ready in seconds.",
    },
    {
        icon: Settings2,
        title: "Set up plans & invite your team",
        description:
            "Create membership plans, add your first members and invite trainers and admins with the right roles.",
    },
    {
        icon: Rocket,
        title: "Run your gym",
        description:
            "Check members in, take payments, run payroll and watch the analytics roll in — all from one dashboard.",
    },
];
